export var AUTH_PATH;
(function (AUTH_PATH) {
    AUTH_PATH["LOGIN_PAGE"] = "/login";
    AUTH_PATH["LOGOUT_PAGE"] = "/logout";
    AUTH_PATH["AUTH_PAGE"] = "/auth";
})(AUTH_PATH || (AUTH_PATH = {}));
